// React
import { useContext, useEffect } from "react"

// Form
import { Controller, useFormContext } from "react-hook-form"

// Components
import { Select } from "components"

// Contexts
import { ProductContext } from "../contexts"

// Third-Party Libraries
import { useLocation } from "react-router-dom"

// Utils
import { DetailFormType } from "../../../utils"

export function ItemOrder(params: {
  getFromState: boolean
}): JSX.Element {
  // Vars
  const getFromState: boolean = Boolean(params.getFromState)

  // Hooks
  const location = useLocation()
  const { data, isLoading } = useContext(ProductContext)

  // Form
  const { control, setValue } = useFormContext<DetailFormType>()

  useEffect(() => {
    // Vars
    const state = location.state

    if (getFromState && data.length && state) {
      // Vars
      const res = data.find(item => item.value === state.product_id)

      if (res) {
        setValue("product_id", res.value)
        setValue("mr_unit_id", res.weight_unit_id)
        setValue("tax_id", res.tax_id)
        setValue("quantity_unit_convention", res.quantity_unit_convention ?? 1)
      }
    }

    // eslint-disable-next-line
  }, [data, location.state, getFromState])

  return (
    <Controller
      name="product_id"
      control={control}
      render={({ field, fieldState }) => (
        <Select
          placeholder="Select Item"
          error={fieldState.error?.message}
          isLoading={isLoading}
          options={data}
          ref={field.ref}
          value={data.find(item => item.value === field.value) ?? null}
          onChange={res => {
            if (res) {
              field.onChange(res.value)
              // @ts-expect-error
              setValue("mr_unit_id", res.weight_unit_id)
              // @ts-expect-error
              setValue("tax_id", res.tax_id)
            }
          }}
        />
      )}
    />
  )
}